"use strict";
/**
 * 初診問診票 ゴリ押し用スクリプト
 *
 * @since 2020/02/03
 * @author Remode design, inc <info@remode-d.jp>
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
class InterviewW {
    constructor() {
        /**
         * 各入力欄へ onChange イベントの設定
         */
        this.appendBirthdayEvents = (birthday) => {
            const { year, month, day, age } = birthday;
            if (year && month && day && age) {
                year.addEventListener('change', () => this.onBirthdayChange(birthday), false);
                month.addEventListener('change', () => this.onBirthdayChange(birthday), false);
                day.addEventListener('change', () => this.onBirthdayChange(birthday), false);
            }
        };
        /**
         * onChange イベント処理 時間差を年齢欄に入力する
         */
        this.onBirthdayChange = (birthday) => {
            const year = birthday.year;
            const month = birthday.month;
            const day = birthday.day;
            const age = birthday.age;
            if (year && month && day && age) {
                const birthdayMoment = (0, moment_1.default)().year(parseInt(year.value)).month(parseInt(month.value) - 1).date(parseInt(day.value));
                if (birthdayMoment.isValid()) {
                    const current = (0, moment_1.default)(new Date());
                    const ageValue = current.diff(birthdayMoment, 'years');
                    if (!(ageValue !== ageValue))
                        age.value = `${ageValue}`;
                }
            }
        };
        /**
         * 住所自動入力
         *
         * @param fields AddrFields
         */
        this.appendPostalcodeEvents = (fields) => {
            const postal = fields.postal;
            const pref = fields.pref;
            const addr = fields.addr;
            if (postal && pref && addr) {
                // @ts-ignore
                $(`[name="${postal.getAttribute('name')}"]`).jpostal({
                    postcode: [`[name="${postal.getAttribute('name')}"]`],
                    address: {
                        [`[name="${pref.getAttribute('name')}"]`]: '%3',
                        [`[name="${addr.getAttribute('name')}"]`]: '%4%5',
                    }
                });
            }
        };
        /**
         * エラー表示 調整
         *
         * できれば使用しない
         */
        this.handleError = () => {
            const $inputs = document.querySelectorAll('.c-Input');
            for (let i = 0; $inputs.length > i; i++) {
                const $input = $inputs[i];
                const hasError = Boolean($inputs[i].querySelector('.err'));
                if (hasError)
                    $input.classList.add('is-error');
            }
        };
        this.w_birthday = {
            year: document.querySelector('[name="w_birth_year"]'),
            month: document.querySelector('[name="w_birth_month"]'),
            day: document.querySelector('[name="w_birth_day"]'),
            age: document.querySelector('[name="w_age"]'),
        };
        this.h_birthday = {
            year: document.querySelector('[name="h_birth_year"]'),
            month: document.querySelector('[name="h_birth_month"]'),
            day: document.querySelector('[name="h_birth_day"]'),
            age: document.querySelector('[name="h_age"]'),
        };
        this.w_addr = {
            postal: document.querySelector('[name="w_postal"]'),
            pref: document.querySelector('[name="w_prefecture"]'),
            addr: document.querySelector('[name="w_address"]'),
        };
        this.h_addr = {
            postal: document.querySelector('[name="h_postal"]'),
            pref: document.querySelector('[name="h_prefecture"]'),
            addr: document.querySelector('[name="h_address"]'),
        };
        this.bindEvents();
    }
    bindEvents() {
        this.appendBirthdayEvents(this.w_birthday);
        this.appendBirthdayEvents(this.h_birthday);
        this.appendPostalcodeEvents(this.w_addr);
        this.appendPostalcodeEvents(this.h_addr);
        this.handleError();
    }
}
window.addEventListener('DOMContentLoaded', () => {
    new InterviewW();
}, false);
